import React from 'react';
import { Sparkles } from 'lucide-react';
import { themes } from './themes';

const DocumentCover = ({ cover, title, theme }) => {
  const t = themes[theme] || themes['modern-minimal'];
  const coverTitle = cover?.title || title || 'Untitled';
  const coverSubtitle = cover?.subtitle || '';
  return (
    <div data-testid="document-cover" className="w-full aspect-[210/297] flex flex-col items-center justify-center text-center relative overflow-hidden" style={{ backgroundColor: t.accent }}>
      <div className="absolute top-12 right-12 w-32 h-32 rounded-full opacity-10" style={{ backgroundColor: t.bg }} />
      <div className="absolute bottom-16 left-16 w-48 h-48 rounded-full opacity-5" style={{ backgroundColor: t.bg }} />
      <div className="absolute top-1/4 left-8 w-16 h-16 rounded-full opacity-8" style={{ backgroundColor: t.bg }} />
      <div className="relative z-10 px-12 max-w-[85%]">
        <div className="mb-8 opacity-70" style={{ color: t.bg }}><Sparkles className="w-12 h-12 mx-auto" strokeWidth={1} /></div>
        <h1 className="leading-tight mb-4" style={{ fontFamily: t.font, fontWeight: 700, fontSize: 'clamp(1.75rem, 4vw, 2.5rem)', color: t.bg, lineHeight: 1.15 }}>{coverTitle}</h1>
        {coverSubtitle && <p style={{ fontFamily: t.bodyFont, fontSize: 'clamp(0.85rem, 2vw, 1.1rem)', color: t.bg + 'BB', lineHeight: 1.6 }}>{coverSubtitle}</p>}
      </div>
      <div className="absolute bottom-8" style={{ color: t.bg + '60', fontFamily: t.bodyFont, fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase' }}>Created with Create by Lumera</div>
    </div>
  );
};

export default DocumentCover;
